import React from 'react';
import { injectLazyLibs } from '@plone/volto/helpers/Loadable/Loadable';

const renderLegend = (colors, labels, values, locale) => {
  return (
    <ul style={{ listStyleType: 'none' }}>
      {colors.map((color, index) => (
        <li
          key={`item-${index}`}
          style={{
            fontSize: '80%',
            textAlign: 'left',
            fontWeight: 300,
          }}
        >
          <div
            style={{
              width: 18,
              height: 18,
              backgroundColor: color,
              display: 'inline-block',
              marginRight: 14,
              verticalAlign: 'middle',
            }}
          ></div>
          <span className="value">
            {Intl.NumberFormat(locale, {
              minimumFractionDigits: 1,
              maximumFractionDigits: 1,
            }).format(values[index])}
          </span>{' '}
          | {labels[index]}
        </li>
      ))}
    </ul>
  );
};

const Chart = ({ data, locale, recharts }) => {
  const colors = data.map((item) => item.color);
  const labels = data.map((item) => item.name);
  const values = data.map((item) => item.v0);
  const {
    BarChart,
    Bar,
    Cell,
    YAxis,
    CartesianGrid,
    ResponsiveContainer,
  } = recharts;

  return (
    <div className="bar-chart">
      <div className="legend">
        {renderLegend(colors, labels, values, locale)}
      </div>
      <ResponsiveContainer width={900} height={500} className="bar-chart">
        <BarChart
          data={data}
          margin={{
            top: 40,
            right: 320,
            left: 0,
            bottom: 40,
          }}
        >
          <CartesianGrid vertical={false} />
          <YAxis
            type="number"
            axisLine={false}
            tickLine={false}
            style={{ fontSize: '60%' }}
          />
          <Bar dataKey="v0" barSize="16">
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default injectLazyLibs('recharts')(Chart);
